import type { BaseOptionType } from 'antd/lib/select';
import { useEffect, useState } from 'react';
// TODO: try to solve different imports in different files - 82948
import { useDebounce } from 'common/hooks/useDebounce';
import { Empty } from '../empty';
import { Select, type SelectProperties } from '../select';
import { Spin } from '../spin';

// eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are constant values
const INITIAL_STATE = { delay: 0, value: '' };

export type DebounceSelectProperties<ValueType, OptionType extends BaseOptionType> = {
  debounceTime?: number;
} & SelectProperties<ValueType, OptionType>;

const DebounceSelect = <ValueType, OptionType extends BaseOptionType>({
  debounceTime = 500,
  onSearch,
  ...restProperties
}: DebounceSelectProperties<ValueType, OptionType>) => {
  const [search, setSearch] = useState(INITIAL_STATE);
  const { isDebouncing, value } = useDebounce(search.value, search.delay);

  useEffect(() => {
    onSearch?.(value);
  }, [value, onSearch]);

  return (
    <Select<ValueType, OptionType>
      notFoundContent={Boolean(restProperties.loading) || isDebouncing ? <Spin /> : <Empty />}
      onOpenChange={() => {
        setSearch(INITIAL_STATE);
      }}
      onSearch={(newValue) => {
        setSearch({ delay: debounceTime, value: newValue });
      }}
      {...restProperties}
    />
  );
};

export default DebounceSelect;
